import React, { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Braintree } from 'modules/braintree';
import { FormControlProps } from '../FormControl/Default';
import { model, Model, schema } from '../QuestionSet/model';
import { ProductInfoProps, VoucherCodeProps } from '../types';
import { ReactComponent as SecureCheckoutIcon } from 'modules/theme/ims/secure-checkout.svg';
import { ReactComponent as SecureCIcon } from 'modules/theme/ims/secure-icon.svg';
import * as QuestionSet from '../QuestionSet';
import Fieldset from 'components/Fieldset';
import PurchaseSummary from '../PurchaseSummary';
import VoucherCode from '../VoucherCode';

import styles from './styles.module.scss';

type PaymentQuestionsProps = {
  defaultValues: Model;
  formControl: React.FC<FormControlProps>;
  handleBack?: () => void;
  handleSubmit: (data: any) => Promise<void>;
  isSubmitting: boolean;
  productInfo: ProductInfoProps;
  voucherCode: VoucherCodeProps;
};

function PaymentQuestions({
  defaultValues,
  formControl,
  handleBack,
  handleSubmit,
  isSubmitting,
  productInfo,
  voucherCode,
}: PaymentQuestionsProps) {
  const isMobileBreakpoint = useMediaQuery({ query: '(max-width: 767px)' });
  const displaySecureIcon = useMediaQuery({ query: '(max-width: 450px)' });

  const FormControl = useMemo(() => formControl, [formControl]);
  return (
    <Braintree<Model>
      className={styles.paymentForm}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      title="Payment details"
      schema={schema[1]}
    >
      {({ control, isFormLoading, isFormSubmitting }) => (
        <React.Fragment>
          <div className={styles.secureIcon}>
            {displaySecureIcon ? <SecureCIcon /> : <SecureCheckoutIcon />}
          </div>
          <Fieldset title="User agreement">
            <QuestionSet.Consent
              control={control}
              isSubmitting={isFormLoading || isFormSubmitting || isSubmitting}
              model={model}
            />
          </Fieldset>

          {isMobileBreakpoint && (
            <PurchaseSummary showBackLink={false} {...productInfo}>
              <VoucherCode
                {...voucherCode}
                isSubmitting={isFormLoading || isFormSubmitting || isSubmitting}
              />
            </PurchaseSummary>
          )}

          <FormControl
            handleBack={handleBack}
            isLoading={isFormLoading}
            isSubmitting={isFormSubmitting || isSubmitting}
          />
        </React.Fragment>
      )}
    </Braintree>
  );
}

export default React.memo(PaymentQuestions) as typeof PaymentQuestions;
